<template>
  <section class="poster">
    <h2 v-html="headline" />
    <p v-for="paragraph in paragraphs" :key="paragraph" v-html="paragraph" />
    <slot></slot>
  </section>
</template>

<script>
export default {
  props: {
    headline: String,
    paragraphs: Array,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors.scss';
@import '~@/assets/styles/fonts.scss';
@import '~@/assets/styles/breakpoints';

.poster {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 170px 0 100px 0;
}

h2 {
  margin-bottom: 12px;
}

p {
  text-align: center;
}

@media (max-width: $page-table-breakpoint) {
  .poster {
    max-width: $page-mobile-large-breakpoint;
    padding: 135px 10px 75px 10px;
  }

  h2 {
    font-size: $font-size-headline-medium !important;
  }
}

@media (max-width: $page-mobile-large-breakpoint) {
  .poster {
    max-width: $page-mobile-small-breakpoint;
    padding: 50px 15px;
  }
}
</style>
